import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";

export function AdvisorAuthShell({ title, subtitle, children, testId }) {
  return (
    <div className="flex min-h-screen flex-col bg-white text-[#3E5641]" data-testid={testId}>
      <header className="border-b border-[#3E5641]/10">
        <div className="container-x flex h-16 items-center justify-between">
          <Logo />
          <span className="mono text-[10px] uppercase tracking-widest text-[#A0553F]">Portal de asesores</span>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm border border-[#3E5641]/10 bg-white p-6 md:p-8">
          <p className="mono text-xs uppercase tracking-widest text-[#A0553F]">Asesores</p>
          <h1 className="mt-2 font-serif text-3xl text-[#3E5641]">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#6B7678]">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </main>
    </div>
  );
}

export function AuthFooterLink({ to, children, testId }) {
  return (
    <p className="mt-6 text-center text-sm">
      <Link to={to} className="text-[#6B7678] underline hover:text-[#3E5641]" data-testid={testId}>{children}</Link>
    </p>
  );
}
